<p>canvas-tracing works!</p>
<div>
    <canvas #myCanvas></canvas>
</div>
<button type="button" (click)="changeCharachter()">Change Charachter</button>